/**
 * Outcome Labels — Maps capability IDs to user-friendly business language.
 * Used in workflow steps, system run timelines, and capability unlock UX.
 * 
 * Principle: Users see outcomes ("Save lead to CRM"), not integrations ("Create contact in HubSpot").
 */

export const CAPABILITY_LABELS = {
  cap_send_email: 'Send message',
  cap_reply_email: 'Reply to message',
  cap_read_email: 'Read incoming messages',
  cap_manage_labels: 'Organize messages',
  cap_create_event: 'Schedule appointment',
  cap_check_availability: 'Check availability',
  cap_reschedule_event: 'Reschedule appointment',
  cap_cancel_event: 'Cancel appointment',
  cap_create_contact: 'Save lead to CRM',
  cap_update_contact: 'Update lead record',
  cap_get_contact: 'Look up lead details',
  cap_search_contact: 'Find existing lead',
  cap_log_activity: 'Log activity',
  cap_send_sms: 'Send text message',
  cap_send_chat_message: 'Notify team',
};

/**
 * Provider-to-friendly-name mapping.
 * Only shown in "details" or expand views, never in primary step labels.
 */
export const PROVIDER_LABELS = {
  gmail: 'Gmail',
  outlook: 'Outlook',
  google_calendar: 'Google Calendar',
  airtable: 'Airtable',
  hubspot: 'HubSpot',
  salesforce: 'Salesforce',
  slack: 'Slack',
  sendgrid: 'SendGrid',
  googlesheets: 'Google Sheets',
  discord: 'Discord',
  microsoft_teams: 'Microsoft Teams',
  twilio: 'Twilio',
};

/**
 * Capability category groupings for the unlock UX.
 */
export const CAPABILITY_CATEGORIES = {
  communication: {
    label: 'Communication',
    capabilities: ['cap_send_email', 'cap_reply_email', 'cap_read_email', 'cap_send_sms', 'cap_send_chat_message'],
  },
  scheduling: {
    label: 'Scheduling',
    capabilities: ['cap_create_event', 'cap_check_availability', 'cap_reschedule_event', 'cap_cancel_event'],
  },
  crm: {
    label: 'Customer management',
    capabilities: ['cap_create_contact', 'cap_update_contact', 'cap_get_contact', 'cap_search_contact'],
  },
  data: {
    label: 'Data & tracking',
    capabilities: ['cap_log_activity', 'cap_manage_labels'],
  },
};

/**
 * Given a provider toolkit slug, returns the list of capabilities it unlocks.
 */
export const PROVIDER_CAPABILITIES = {
  gmail: ['cap_send_email', 'cap_reply_email', 'cap_read_email', 'cap_manage_labels'],
  outlook: ['cap_send_email', 'cap_reply_email'],
  google_calendar: ['cap_create_event', 'cap_check_availability', 'cap_reschedule_event', 'cap_cancel_event'],
  airtable: ['cap_create_contact', 'cap_update_contact', 'cap_get_contact', 'cap_search_contact', 'cap_log_activity'],
  hubspot: ['cap_create_contact', 'cap_update_contact', 'cap_get_contact', 'cap_search_contact', 'cap_send_email'],
  salesforce: ['cap_create_contact', 'cap_update_contact', 'cap_get_contact', 'cap_search_contact'],
  slack: ['cap_send_chat_message'],
  sendgrid: ['cap_send_email'],
  googlesheets: ['cap_log_activity'],
  discord: ['cap_send_chat_message'],
  microsoft_teams: ['cap_send_chat_message'],
  twilio: ['cap_send_sms'],
};
